import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { FlatActionList } from "@towersystems/roam-common-native";
import { moneyToFormattedString } from "../../../../utilities/money";
import { Text } from "@towersystems/roam-common-native";
import Sale from "../../../../utilities/data/model/Sale";

export interface SaleTotalsSummaryProps {
  sale: Sale;
}

const getObservables = ({ sale }: { sale: Sale }) => ({
  totals: sale.totals,
});

export interface SaleTotalsSummaryRendererProps
  extends ExtractedObservables<ReturnType<typeof getObservables>> {}

const SaleTotalsSummaryRenderer = ({
  totals,
}: SaleTotalsSummaryRendererProps) => {
  return (
    <FlatActionList
      items={[
        {
          key: "discount",
          title: "Discount",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(totals.totalDiscount)}
            </Text>
          ),
        },
        {
          key: "tax",
          title: "Tax",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(totals.totalTax)}
            </Text>
          ),
        },
        {
          key: "total",
          title: "Total",
          componentRight: () => (
            <Text variant="heading1">
              {moneyToFormattedString(totals.totalPrice)}
            </Text>
          ),
        },
      ]}
    />
  );
};

const enhance = withObservables(["sale"], getObservables);

export const SaleTotalsSummary = enhance(SaleTotalsSummaryRenderer);
